import React, { useState } from 'react';
import { ImageBadge, VideoTile } from 'seduo-ui';
const Example = () => {
    const [studyPlanActive, setStudyPlanActive] = useState(false);
    const handleStudyPlanAction = (action) => {
        console.log(action);
        setStudyPlanActive(action === 'add');
    };
    return (<VideoTile href="#" title="Moric test kurz" lector="Pavel Moric" imageSrc="https://dummyimage.com/520x350/9fa4a8/fff.png" overlay={{ bottomLeft: <ImageBadge theme="dark" text="1h 55min"/> }} video={{
            src: 'https://lmc-vod.ssl.cdn.cra.cz/0143/9518/cze-hd2-s0U5SoTh.mp4',
            type: 'video/mp4',
        }} studyPlan={{
            onAddToStudyPlan: () => handleStudyPlanAction('add'),
            onRemoveFromStudyPlan: () => handleStudyPlanAction('remove'),
            active: studyPlanActive,
            title: studyPlanActive ? 'remove from study plan' : 'add to study plan',
        }}/>);
};
export default Example;
